// Opens a backend-generated PDF document in a new browser tab.
export function openPdf(path) {
  const url = `${process.env.REACT_APP_BACKEND_URL}/api${path}`;
  window.open(url, "_blank", "noopener");
}
